






























import Vue from 'vue'
import ModalSocialShare from '@/common/components/ModalSocialShare.vue'
import { gaEventTracker, EVENT_CATEGORIES, EVENT_ACTIONS } from '@/common/utils'

export default Vue.extend({
  components: {
    ModalSocialShare
  },
  props:{
    eventLabel: {
      type: String,
      required: true
    }
  },
  data(): {
     isOpenModalSocialShare: boolean
  } {
    return {
      isOpenModalSocialShare: false
    }
  },
  computed: {
    editorPage(): boolean {
      return this.$route.path == '/editor'
    },
    eventCategory(): string {
      return this.editorPage ? EVENT_CATEGORIES.EDITOR : EVENT_CATEGORIES.PRODUCT_DETAIL
    }
  },
  created() {
    this.$root.$on('showSocialShareModal', eventData =>{
      this.openShareModalHandler(eventData)
    })
  },
  methods: {
    openShareModalHandler(eventData?:string){
      this.isOpenModalSocialShare = true
      const payload = {
        category: this.eventCategory,
        action: EVENT_ACTIONS.OPEN_DIALOG,
        label:eventData ?? this.eventLabel
      }
      gaEventTracker(payload)
    }
  }
})
